<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  mixins: [],
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  directives: {},
  filters: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style>
html,
body {
  background-color: #ffffff;
}
* {
  padding: 0;
  margin: 0;
  border: 0;
  box-sizing: border-box;
}
</style>
<style scoped lang="scss"></style>
